import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { FunctionsService } from 'src/app/services/functions.service';

@Component({
  selector: 'app-payment-processed',
  templateUrl: './payment-processed.component.html'
})

export class PaymentProcessedComponent implements OnInit {
  
  constructor(
    public activeModal: NgbActiveModal,
    public functionsService: FunctionsService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    var language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
    this.translate.setDefaultLang(language);
  }
}
